export default class Message {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.closeButton = this.DOM.el.querySelector('button');
        this.uuid = this.DOM.el.dataset.messageUuid;
        this.uuids = [];

        this.init();
        this.initEvents();

    }

    init() {
        this.uuids = sessionStorage.getItem('closed-messages');

        if (this.uuids) {
            this.uuids = JSON.parse(this.uuids);
        } else {
            this.uuids = [];
        }

        if (!this.uuids.includes(this.uuid)) {
            this.DOM.el.classList.add('is-visible');
            this.DOM.el.clientHeight;
            this.DOM.el.classList.add('is-open');
        }
    }

    initEvents() {
        /* Add event listener */
        this.DOM.closeButton.addEventListener('click', (e) => {
            e.preventDefault();

            this.DOM.el.classList.remove('is-open');
            setTimeout(() => {
                this.DOM.el.classList.remove('is-visible');
            }, 200);

            this.uuids.push(this.uuid);

            sessionStorage.setItem("closed-messages", JSON.stringify(this.uuids));

        });
    }
}

const messageNodes = Array.from(document.querySelectorAll('[data-message]'));
if (messageNodes !== null) {
    messageNodes.forEach((node) => { new Message(node); });
}
